import { FC } from 'react';

import VideoMediaUploader, { MediaUploaderProps } from '@zvuk-b2b/react-uikit/ui/VideoMediaUploader';

import { MediaListItemIconsUploader } from '../MediaList/MediaListItemIcons';

import styles from './index.module.scss';
import VideoMediafilePreviewItemContent from '../VideoMediafilePreviewItem/VideoMediafileItemContent';

type MediaUploaderWrapperProps = Omit<MediaUploaderProps, 'className' | 'postfix' | 'renderer'> & {
  hintText?: string;
  mediaUploaderClassname?: string;
};

const VideoMediaUploaderWrapper: FC<MediaUploaderWrapperProps> = ({
  accept,
  buttonTitle,
  description,
  elementId,
  isLoading,
  items,
  isMediaUploaderVisible,
  multiple,
  hintText,
  onDrop,
  onRemove,
  onRetry,
  isSortable,
  onReorder,
  mediaUploaderClassname,
}) => (
  <>
    {hintText && <div className={styles.MediaUploaderWrapperHint}>{hintText}</div>}
    <VideoMediaUploader
      elementId={elementId}
      accept={accept}
      items={items}
      isLoading={isLoading}
      buttonTitle={buttonTitle}
      description={description}
      onDrop={onDrop}
      onRemove={onRemove}
      onRetry={onRetry}
      isSortable={isSortable}
      onReorder={onReorder}
      isMediaUploaderVisible={isMediaUploaderVisible}
      multiple={multiple}
      renderer={VideoMediafilePreviewItemContent}
      postfix={MediaListItemIconsUploader}
      className={mediaUploaderClassname}
    />
  </>
);

export default VideoMediaUploaderWrapper;
